module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "sign",
    attrs: {
      "id": "sign"
    }
  }, [_c('div', {
    staticClass: "sTitle"
  }, [_vm._v("\n        注册\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sign-body"
  }, [_c('div', {
    staticClass: "s-form",
    attrs: {
      "id": "signUp"
    }
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step1),
      expression: "step1"
    }],
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('label', [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.phone),
      expression: "newUser.phone"
    }],
    ref: "phone",
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnPhone),
      expression: "warnPhone"
    }],
    ref: "warn",
    staticClass: "warning"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.vertify),
      expression: "newUser.vertify"
    }],
    ref: "vertify",
    staticStyle: {
      "flex": "1",
      "margin-right": "5px"
    },
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.vertify)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "vertify", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasCounted),
      expression: "!hasCounted"
    }],
    ref: "getVCode",
    staticClass: "btn-code",
    on: {
      "click": _vm.getVertifyCode
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasCounted),
      expression: "hasCounted"
    }],
    staticClass: "btn-count"
  }, [_vm._v(_vm._s(_vm.count) + "秒后重新发送")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vertifyTip),
      expression: "vertifyTip"
    }],
    ref: "vertifyTip",
    staticClass: "warning"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signUp.apply(null, arguments)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step2),
      expression: "step2"
    }]
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "passwordTip",
    staticClass: "warning"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "signUp"
    }
  }, [_c('input', {
    staticClass: "btn",
    staticStyle: {
      "margin-bottom": "6px"
    },
    attrs: {
      "type": "submit",
      "value": "注册"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regSuccess),
      expression: "regSuccess"
    }]
  }, [_vm._v("注册成功!")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "rtSignUp",
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("\n            登录\n          ")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e6521f7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/signup/signup.vue
// module id = 507
// module chunks = 1